import { inject, Inject, Injectable, Optional } from '@angular/core';
import {
  AssortmentService,
  AuthService,
  BackendFeatureService,
  BackendInterceptor,
  BaseViewConfigService,
  CartService,
  CustomerService,
  DocumentsService,
  GungCompanyService,
  GungFlowService,
  GungModalService,
  GungNavbarService,
  LocationConfigService,
  MetadataService,
  NavbarConfigService,
  NavigationConfig,
  NewsActionConfigService,
  PriceConfigService,
  SelectedCustomerService,
  SelectedSupplierService
} from 'gung-standard';
import { catchError, first, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { HlDisplayPortalFeaturesService, ProductListInfoSettingsGroup } from './hl-display-portal-features.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayNavbarConfigService extends NavbarConfigService {
  protected hlDisplayPortalFeaturesService = inject(HlDisplayPortalFeaturesService);

  public getBackgroundLoginUrlObservable(): Observable<string> {
    if (this.hlDisplayPortalFeaturesService.getPortalName() === 'pharmacie') {
      return of(
        'https://cdn3.gung.io/fit-in/0x0/filters:etag(e8a9f84c0861bc5739df923d23d025e3)/hldisplay/pharmacie-images/Connection page.jpg'
      );
    }

    return this.gungCompanyService.getBackgroundLoginUrlObservable().pipe(
      map(loginBackgroundImage => {
        console.log(loginBackgroundImage);
        return loginBackgroundImage || this.getBackgroundLoginUrl();
      })
    );
  }

  public getProductListNavigationQueryParams(): Observable<{ [key: string]: string }> {
    return this.authService.getRoles().pipe(
      switchMap(roles =>
        forkJoin({
          roles: of(roles),
          productListInfoSettings: this.hlDisplayPortalFeaturesService
            .getPortalFeatureGroup('productListInfoSettingsGroup')
            .pipe(
              first(),
              map(navbarSettings => navbarSettings as ProductListInfoSettingsGroup),
              catchError(_ => of(null))
            )
        })
      ),
      switchMap(({ roles, productListInfoSettings }) => {
        const queryParams: { [key: string]: string } = {};

        if (roles.includes('MANAGER') && productListInfoSettings.templatePortal) {
          queryParams.filters = 'ASSORTMENT_TYPE__:__T';
        } else {
          queryParams.filters = 'ASSORTMENT_TYPE__:__C_____S';
        }

        if (!!productListInfoSettings.defaultSorting) {
          queryParams.sort = productListInfoSettings.defaultSorting;
        }

        return of(queryParams);
      })
    );
  }
}
